import SectionTitle from '../../components/SectionTitle';
import { VStack, Text, UnorderedList, ListItem } from '@chakra-ui/react';

export default function AboutSection() {
  return (
    <VStack w="100%" pt="20" pb="10">
      <SectionTitle title="$XED: New Year, New Token" />
      <VStack
        align="start"
        spacing="6"
        p="6"
        bg="whiteAlpha.200"
        backdropFilter="blur(25px)"
        borderRadius="16px"
        color="whiteAlpha.800"
      >
        <VStack align="start" spacing="0.5">
          <Text fontSize="md" fontWeight="semibold" pb="1.5" color="white">
            What's Happening?
          </Text>
          <Text fontSize="sm">
            As Exeedme enters 2025 and evolves into a DAO structure, we're upgrading our token
            contract to enhance security and align with our new governance model. This will allow us
            to concentrate liquidity that is spread across Ethereum, BNB Chain and Polygon in order
            to improve liquidity efficiency. It will also reduce the risk and hurdles of having part
            of $XED Supply in BNB Chain through the Multichain bridge that suffered sustained
            damages and affected the possibility of users and Exeedme itself to bridge tokens from
            BNB Chain to Ethereum and vice versa. This migration will be the stepping stone to
            empower $XED holders with real governance over our ecosystem of products: Tournament
            Platform, GGCASE, Skins Profit, and XKIT.
          </Text>
          <Text fontSize="md" fontWeight="semibold" pt="6" pb="1.5" color="white">
            TL;DR
          </Text>
          <UnorderedList>
            <ListItem>
              <Text fontSize="sm">$XED is migrating to a new smart contract on Ethereum</Text>
            </ListItem>
            <ListItem>
              <Text fontSize="sm">You need to act to Claim the New $XED Token</Text>
            </ListItem>
            <ListItem>
              <Text fontSize="sm">
                The earlier you Stake $XED tokens, the more rewards you will get from Exeedme
                ecosystem
              </Text>
            </ListItem>
            <ListItem>
              <Text fontSize="sm">12-month migration window starting January 14, 2025</Text>
            </ListItem>
            <ListItem>
              <Text fontSize="sm">Migration coincides with Exeedme DAO activation</Text>
            </ListItem>
            <ListItem>
              <Text fontSize="sm">All products revenue streams will fuel $XED buybacks</Text>
            </ListItem>
          </UnorderedList>
        </VStack>
      </VStack>
    </VStack>
  );
}
